export function findNestedObject(obj, path) {
  let currentLevel = obj;

  for (let title of path) {
    let foundItem = currentLevel.subPages?.find((item) => item.title === title);

    if (foundItem) {
      currentLevel = foundItem;
    } else {
      return null;
    }
  }

  return currentLevel;
}
